import LastReadingCard from "./LastReadingCard";
export default LastReadingCard;
